<template>
    <PageContent slug="guidelines" />
</template>

<script setup>
import PageContent from './PageContent.vue'
</script>

